import React, {
  useContext,
  useEffect
} from 'react';

import { SidebarContext } from '../../../layouts/Technician';

interface Props {}

const TechnicianInvoices: React.FC<Props> = () => {
  const { setCurrentPage } = useContext(SidebarContext)

  useEffect(() => {
    setCurrentPage('invoices')
  }, []);

  return (
    <>
      <div>ใบเสนอราคา</div>
    </>
  )
}

export default TechnicianInvoices;
